module.exports = __webpack_public_path__ + "static/media/nz-beef.ecd6918b.png";